<template>
  <section>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-card class="mb-6 ml-6 mr-2 mt-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>Ajout d'un verset</v-card-title>
            <v-card-text class="mt-4">
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-textarea v-model="versetArabe" name="input-7-1" variant="filled" label="آية" auto-grow outlined
                    :rules="rule" required></v-textarea>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-textarea v-model="versetFrancais" name="input-7-1" variant="filled" label="verset en français" auto-grow
                    :rules="rule" required outlined></v-textarea>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                  <v-textarea v-model="versetAnglais" name="input-7-1" variant="filled" label="verset en anglais" auto-grow
                    :rules="rule" required outlined></v-textarea>
                </v-col>
                <v-col cols="12" sm="12" md="12" xs="12">
                  <v-textarea v-model="phonetic" label="Phonétique " name="input-7-1" variant="filled" auto-grow
                    :rules="rule" required outlined />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <VueEditor v-model="tafsyrVerset" auto-grow outlined label="Tafsyr" :rules="rule"
                    placeholder="Tafsyr">
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <VueEditor v-model="tafsyrVersetEn" auto-grow outlined label="Tafsyr Englais" :rules="rule"
                    placeholder="Tafsyr Englais">
                  </VueEditor>
                </v-col>
                <v-col cols="12" sm="6" md="3" xs="12">
                  <v-text-field v-model="numVerset" hide-details outlined type="number"
                    oninput="if(this.value < 1) this.value = 1;" label="Numero verset" :rules="rule" />
                </v-col>
                <!--
                <v-col cols="12" sm="6" md="3" xs="12">
                  <v-select
                    v-model="idThemeSelected"
                    clearable
                    label="Theme"
                    :items="themeArray"
                    item-text="title"
                    item-value="id"
                    outlined
                    @change="getListProphete"
                  ></v-select>
                </v-col>
               
                <v-col cols="12" sm="6" md="3" xs="12" v-if="idThemeSelected">
                  <v-select
                    return-object
                    v-model="Soustheme"
                    clearable
                    label="Sous Theme"
                    :items="filteredProphets"
                    item-text="name"
                    outlined
                  ></v-select>
                </v-col>-->
                <v-col cols="12" sm="6" md="3" xs="12">
                  <v-select v-model="hizb" clearable label="Hizb" :items="hizbArray" item-text="name"
                    item-value="hizbId" outlined :rules="rule"></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="3" xs="12">
                  <v-select v-model="surat" clearable label="Surat" :items="suratArray" item-text="frenchName"
                    :return-object="true" :rules="rule" outlined></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <div class="d-flex flex-row-reverse">
                    <v-btn class="ml-6 mt-4" color="info" @click="validate" :loading="loadingAddVerset">
                      Enregistrer
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="mb-6 ml-6 mt-6 mr-2">
      <v-card-title>Liste des versets</v-card-title>
      <v-card-text class="mt-4">
        <v-row>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" hide-details clearable
            :search="search" style="padding: 15px" @click:clear="clearVerset()"></v-text-field>

          <v-btn style="margin-top: 15px; margin-right: 10px" color="info" @click="searchVerset">
            Recherche
          </v-btn>
          <v-btn style="margin-top: 15px; margin-right: 10px" color="error" @click="clearVerset()">
            Clear
          </v-btn>
        </v-row>
      </v-card-text>
      <v-data-table style="margin-top: 30 px" hide-default-footer :loading="isLoadingTables" loading-text="Loading..."
        :headers="headers" :items="versetArray" class="elevation-1">
        <template v-slot:item.tafsyr="{ item }" style="mou">
          <template v-if="getPlainText(item.tafsyr).split(' ').length > 8">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <pre v-bind="attrs" v-on="on" style="cursor: pointer">
                {{ truncateText(getPlainText(item.tafsyr), 8) }}
              </pre>
              </template>
              <span style="cursor: pointer">{{
                getPlainText(item.tafsyr)
              }}</span>
            </v-tooltip>
          </template>
          <template v-else>
            <pre style="cursor: pointer">
            {{ truncateText(getPlainText(item.tafsyr), 8) }}
          </pre>
          </template>
        </template>
        <template v-slot:item.supprimer="{ item }">
          <v-icon @click="suppressionAction(item.versetId)">
            {{ icons.mdiDeleteOutline }}
          </v-icon>
        </template>
        <template v-slot:item.modifier="{ item }">
          <v-icon @click="redirectToEditAction(item)">
            {{ icons.mdiPencil }}
          </v-icon>
        </template>
      </v-data-table>

      <v-pagination v-if="showPagination" v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="dialogAddVerset" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir ajouter le verset ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="reinitialisationFormulaire()">
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="handleButtonClick()" :loading="loadingAddVerset">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row justify="center">
      <v-dialog v-model="dialogDeleteVerset" max-width="530">
        <v-card>
          <v-card-title class="text-h6">
            Etes vous sur de vouloir supprimer le Verset ?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="dialogDeleteVerset = false">
              Annuler
            </v-btn>

            <v-btn color="info darken-1 " text @click="deleteVerset()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--  Add Verset Groupe-->
    <v-row justify="center">
      <v-dialog v-model="dialogAddGroupe" max-width="600">
        <v-card>
          <v-card-title style="text-align: center" class="justify-center mb-2">
            Tafsir Du verset Groupe Avec le Sous Theme
            <a style="margin-left: 5px">{{ Soustheme.name }} </a>
          </v-card-title>

          <v-card-title>
            Sélectionner le début et la fin du verset Groupe
          </v-card-title>
          <v-col v-if="surat" style="padding: 25px">
            <v-range-slider v-model="range" :max="surat === null ? 1 : surat.versetNumber" :min="min" hide-details
              class="align-center">
              <template v-slot:prepend>
                <v-text-field :value="range[0]" class="mt-0 pt-0" hide-details single-line type="number"
                  style="width: 60px" @change="$set(range, 0, $event)"></v-text-field>
              </template>
              <template v-slot:append>
                <v-text-field :value="range[1]" class="mt-0 pt-0" hide-details single-line type="number"
                  style="width: 60px" @change="$set(range, 1, $event)"></v-text-field>
              </template>
            </v-range-slider>
          </v-col>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="error darken-1 error" text @click="dialogAddGroupe = false">
              Annuler
            </v-btn>

            <v-btn :disabled="tafsyrVerset.length <= 0" color="info darken-1 " text @click="AddGroupeVerset()">
              Confirmer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </section>
</template>
<script>
import { component as VueCodeHighlight } from "vue-code-highlight";
import { mdiPlus, mdiDeleteOutline, mdiPencil } from "@mdi/js";
import Constant from "@/utils/constants";
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import {
  getAllHizb,
  getAllSurat,
  getAllTheme,
  getAllVerset,
  getAllVersetWithPagination,
  getAllProphete,
} from "@/views/qorani/services/services";
export default {
  components: { VueEditor, VueCodeHighlight },
  data() {
    return {
      showPagination: true,
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      min: 1,
      max: 800,
      range: [0, 1],
      dialogAddGroupe: false,
      PropheteArray: [],
      filteredProphets: [],
      idVersetSupprimmer: null,
      dialogDeleteVerset: false,
      icons: {
        mdiPlus,
        mdiDeleteOutline,
        mdiPencil,
      },
      hizbArray: [],
      suratArray: [],
      Soustheme: [],
      valid: true,
      rule: [(v) => !!v || "Ce champ est requis"],
      versetArabe: "",
      phonetic: "",
      versetFrancais: "",
      versetAnglais: "",
      tafsyrVerset: "",
      tafsyrVersetEn: "",
      numVerset: "",
      hizb: null,
      surat: null,
      verset: {
        arabic_text: "",
        french_text: "",
        english_text: "",
        verse_number: null,
        tafsyr: "",
        suratId: null,
        hizbId: null,
        themeId: null,
        sous_themeId: null,
      },
      themeArray: [],
      loadingAddVerset: false,
      dialogAddVerset: false,
      versetArray: [],
      isLoadingTables: false,
      headers: [
        { text: "Verset en arabe", value: "arabic_text", align: "center" },
        { text: "Verset en français", value: "french_text" },
        { text: "Verset en anglais", value: "english_text" },
        { text: "Phonétique", value: "phonetic", align: "center" },
        { text: "Tafsyr", value: "tafsyr", align: "center" },
        { text: "Numéro verset", value: "verse_number", align: "center" },
        { text: "Modifier", value: "modifier", align: "center" },
        { text: "Supprimer", value: "supprimer", align: "center" },
      ],
      listProfet: [],
      idThemeSelected: null,
      listPropheteId: { listId: [] },
      versetGroup: {
        suratId: "",
        verset_start: "",
        verset_end: "",
      },
      PropheteToVerset: {
        versetId: "",
        propheteId: "",
        tafsyr: "",
        versetGroupId: "",
      },
    };
  },

  methods: {
    async clearVerset() {
      this.search = "";
      this.isLoadingTables = true;
      const responseVerset = await getAllVersetWithPagination(0, 10);
      this.pageCount = responseVerset.nbrTotalPage;
      this.versetArray = responseVerset.versetList;
      this.isLoadingTables = false;
      this.showPagination = true;
    },
    async searchVerset() {
      this.showPagination = false;
      this.isLoadingTables = true;
      const body = {};
      body.keyWord = this.search;
      const response = await fetch(Constant.QORANI + "verset/findByKeyword", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      this.versetArray = await response.json();
      this.isLoadingTables = false;
    },
    handleButtonClick() {
      if (Object.keys(this.Soustheme).length > 0) {
        this.ajoutVerset();
        this.dialogAddGroupe = true;
      } else {
        this.ajoutVerset();
      }
    },

    /* async getListProphete() {
      if (this.idThemeSelected === null) {
        this.filteredProphets = [];
        return;
      }
      this.filteredProphets = this.PropheteArray.filter((prophet) =>
        prophet.listThemeId.includes(this.idThemeSelected)
      );
    },*/
    redirectToEditAction(item) {
      this.$router.push({
        name: "EditVerset",
        params: {
          suratId: item.suratId,
          edit: true,
          complaint: false,
          versetId: item.versetId,
        },
      });
    },
    suppressionAction(item) {
      this.idVersetSupprimmer = item;
      this.deleteVerset();
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.loadingAddVerset = true;
        this.ajoutVerset();
      }
    },
    reinitialisationFormulaire() {
      this.dialogAddVerset = false;
      this.$refs.form.reset();
    },

    async AddGroupeVerset() {
      this.versetGroup.suratId = this.surat.suratId;
      this.versetGroup.verset_start = this.range[0];
      this.versetGroup.verset_end = this.range[1];

      try {
        // Add versetGroup
        const response1 = await fetch(Constant.QORANI + "versetGroup/add", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.versetGroup),
        });

        if (!response1.ok) {
          throw new Error("Error adding versetGroup");
        }

        const data1 = await response1.json();

        // Add PropheteToVerset
        this.PropheteToVerset.versetGroupId = data1.versetGroupId;
        this.PropheteToVerset.propheteId = this.Soustheme.id;

        const response2 = await fetch(
          Constant.QORANI + "verset/addPropheteToVerset",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.PropheteToVerset),
          }
        );

        if (!response2.ok) {
          throw new Error(
            "Une erreur est survenue lors de l'ajout du verset, veuillez réessayer plus tard. Merci."
          );
        }

        // Reload the page or handle success
        window.location.reload();
      } catch (error) {
        console.error("An error occurred:", error);
        alert(
          "Une erreur est survenue lors de l'ajout du verset, veuillez réessayer plus tard. Merci."
        );
      }
    },

    async ajoutVerset() {
      this.loadingAddVerset = true;
      this.verset.arabic_text = this.versetArabe;
      this.verset.phonetic = this.phonetic;
      this.verset.french_text = this.versetFrancais;
      this.verset.english_text = this.versetAnglais;
      this.verset.tafsyr = this.tafsyrVerset;
      this.verset.tafsyrEn = this.tafsyrVersetEn;
      this.verset.verse_number = Number(this.numVerset);
      this.verset.themeId = this.idThemeSelected;
      this.verset.suratId = this.surat.suratId;
      this.verset.hizbId = this.hizb;
      this.verset.sous_themeId = this.sousTheme;

      const response = await fetch(Constant.QORANI + "verset/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.verset),
      });

      try {
        if (Object.keys(this.Soustheme).length > 0) {
          const data = await response.json();
          this.PropheteToVerset.versetId = data.versetId;
        } else {
          this.loadingAddVerset = false;
          this.dialogAddVerset = false;
          window.location.reload();
        }
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du verset, veuillez réessayez plus tard, Merci."
        );
      }
    },
    getPlainText(html) {
      const temporaryDiv = document.createElement("div");
      temporaryDiv.innerHTML = html;
      return temporaryDiv.textContent || temporaryDiv.innerText || "";
    },
    truncateText(text, maxLength) {
      const words = text.split(" ");

      if (words.length <= maxLength) {
        return text;
      } else {
        return (
          words.slice(0, maxLength).join(" ") +
          (words.length > maxLength ? "..." : "")
        );
      }
    },
    async deleteVerset() {
      const responseCategorie = await fetch(
        Constant.QORANI + `verset/delete/${this.idVersetSupprimmer}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      try {
        this.dialogDeleteVerset = false;
        window.location.reload();
      } catch (error) {
        alert(
          "Une erreur est survenue lors de la suppression du juz, veuillez réessayez plus tard, Merci."
        );
        this.dialogDeleteVerset = false;
      }
    },

    // fonction de recuperation des sous themes
    /* async GetsousTheme() {
      this.listProfet = [];
      this.sousTheme = null;
      for (var i = 0; i <= this.themeArray.length; i++) {
        if (
          this.themeArray[i] !== undefined &&
          this.themeArray[i].id == this.idThemeSelected
        ) {
          this.listPropheteId.listId = this.themeArray[i].list_Prophets_id;
        }
      }
      const responseCategorie = await fetch(
        Constant.QORANI + `prophete/getListPropheteWhereIdIn`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.listPropheteId),
        }
      );

      try {
        var response = await responseCategorie.json();
        for (var i = 0; i <= response.length; i++) {
          this.listProfet.push(response[i]);
        }
      } catch (error) {
        alert(
          "Une erreur est survenue lors de l'ajout du verset, veuillez réessayer plus tard, Merci."
        );
      }
    },*/
  },
  computed: {},
  watch: {
    async page(newValue) {
      this.isLoadingTables = true;

      const responseVerset = await getAllVersetWithPagination(
        newValue - 1,
        this.itemsPerPage
      );
      this.versetArray = responseVerset.versetList;

      this.isLoadingTables = false;
    },
  },
  async created() {
    this.isLoadingTables = true;
    this.PropheteArray = await getAllProphete();
    // this.themeArray = await getAllTheme();
    this.hizbArray = await getAllHizb();
    this.suratArray = await getAllSurat();
    const responseVerset = await getAllVersetWithPagination(0, 10);
    this.pageCount = responseVerset.nbrTotalPage;
    this.versetArray = responseVerset.versetList;
    this.isLoadingTables = false;
  },
};
</script>
<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import "~quill/dist/quill.core.css";
@import "~quill/dist/quill.bubble.css";
@import "~quill/dist/quill.snow.css";
</style>
